<div class="grid-container grid-1" [formGroup]="form">
    <ui-form-field [label]="'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.SCENARIO_NAME' | translate">
        <input
            advizeoInput
            formControlName="name"
            [required]="true"
            [placeholder]="'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.SCENARIO_NAME_PLACEHOLDER' | translate"
        />
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>

    <ui-form-field [label]="'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.UNIVERSE' | translate">
        <ui-select formControlName="universeId" [options]="universeIds$ | async" [hideSearch]="true" [required]="true">
            <ng-template let-option="option">{{ option | referenceListLabel: 'universe' }}</ng-template>
        </ui-select>
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>

    <ui-form-field [label]="'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.TARGET_MEASURE' | translate">
        <ui-select formControlName="targetMeasure" [options]="targetMeasures$ | async" [hideSearch]="true" [required]="true">
            <ng-template let-option="option">
                {{ 'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.TARGET_MEASURES.' + option | uppercase | translate }}
            </ng-template>
        </ui-select>
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>

    <ui-form-field [label]="'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.MEASURE_LEVEL' | translate">
        <ui-select formControlName="measureLevel" [options]="measureLevels$ | async" [hideSearch]="true" [required]="true">
            <ng-template let-option="option">
                {{ 'PAGES.ALERT_SCENARIO_EDITION.DRIFT_FORM.MEASURE_LEVELS.' + option | uppercase | translate }}
            </ng-template>
        </ui-select>
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>
</div>
